import Axios from 'axios'

const api = '/api/news';
export default {
  // 删除
  async listDelectInformation(data) {
    let url = '/api/informationPublic/listDelectInformation';
    return new Promise(resolve => {
      Axios.post(url,data).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },


  // 查看列表详情
  async queryInfomationDetails(data) {
    let url = '/api/informationPublic/queryInfomationDetails';
    return new Promise(resolve => {
      Axios.get(url,{params:data}).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },


  // 信息公开    保存
  async saveInformation(data) {
    let url = '/api/informationPublic/saveInformation';
    return new Promise(resolve => {
      Axios.post(url,data).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },
   // 信息公开    列表
   async selectList(data) {
    let url = '/api/informationPublic/selectList';
    return new Promise(resolve => {
      Axios.post(url,data).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },



  async getList(data) {
    let url = api+'/getList';
    return new Promise(resolve => {
      console.log(JSON.stringify(data));
      Axios.get(url,{params:data}).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },
  async get(data) {
    let url = api+'/getNews?id='+data;
    return new Promise(resolve => {
      Axios.get(url).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },
  async delete(data) {
    let url = api+'/delete';
    return new Promise(resolve => {
      Axios.post(url,data).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },

  async save(data) {
    let url = api+'/saveNews';
    return new Promise(resolve => {
      Axios.post(url,data).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },

  async updateTop(data){
    let url = api+'/updateTop';
    return new Promise(resolve => {
      Axios.get(url,{params:data}).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/news.js